module.exports = {
  localeName: 'sv-SE',
  momentFormat: 'YYYY-MM-DD',
};
